import type { CartItem, Ticket } from '@/store/cartStore';
import type { Promocode } from './promocode-eligibility';
import { isTargetedGiftCart } from './promocode-eligibility';

export function getGiftRedemptionQuery(params: { get: (key: string) => string | null }): string {
    if (params.get('redeem') !== 'gift') return '';
    const ticket = params.get('ticket');
    return `?redeem=gift${ticket ? `&ticket=${encodeURIComponent(ticket)}` : ''}`;
}

export function isGiftRedemptionProduct(
    ticket: Ticket,
    targetId: string | null,
    festivalId?: string,
): boolean {
    return (
        ticket.id === targetId &&
        ticket.festival_id === festivalId &&
        !ticket.is_gift &&
        !ticket.usage_limits.single_use &&
        ['ONLINE', 'BOTH'].includes(ticket.purchase_location)
    );
}

export function canRedeemGiftAfterSales(items: CartItem[], promocode: Promocode | null): boolean {
    return (
        !!promocode?.gift_target_ticket_id &&
        promocode.percentage === 100 &&
        isTargetedGiftCart(items, promocode)
    );
}

export function isGiftRedemptionRoute(segments: string[]): boolean {
    if (segments[1] === 'api') {
        return segments.length === 3 && ['check-user-exists', 'get-ip'].includes(segments[2]);
    }
    if (!['en', 'fr'].includes(segments[1])) return false;
    return [
        'tickets-and-venues',
        'checkout',
        'checkout/payment',
        'sign-in',
        'sign-up',
        'forgot-password',
        'reset-password',
        'account',
        'account/my-tickets',
        'account/order-history',
    ].includes(segments.slice(2).join('/'));
}
